export const USER_HOME_HELPER = Object.freeze({
    HOME: (user = null, fallback = "/") => {
        if (user?.homePath) return user.homePath;
        if (user?.dashboardPath) return user.dashboardPath;
        return fallback || "/";
    },
});
